<template>
<div>
<div class="modal " id="colorModal" tabindex="-1" role="dialog">
<div class="modal-dialog modal-dialog-centered" role="document">
<div class="modal-content">
<div class="modal-header text-nowrap">
    <h4 class="modal-title">
    <i style="color:blue" class="fas fa-palette mr-2" aria-hidden="true"></i>        
    
    <strong>CREA COLORE</strong></h4>
</div>
<div class="modal-body" >
<form v-on:submit.prevent="saveData()">

    <div class="form-group">
    <input required type="text" v-focus class="form-control" id="inputColor" placeholder="Inserire il nuovo colore" v-model="color">
    <small style="color:red" v-if="err" id="codeHelp" class="form-text">
    <strong>COLORE GIA' ESISTENTE.</strong>
    </small>
    
    
    </div>
    <button @click="err=false" data-dismiss="modal" type="button" class="btn btn-secondary float-left">
      <i class="fas fa-reply mr-2" aria-hidden="true"></i>
      Annulla</button>
    <button :disabled="spinner==true" type="submit" class="btn btn-primary float-right">
        <i class="fas fa-save mr-2" aria-hidden="true"></i>   
        SALVA
         <span v-if="spinner"  class="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true"></span>
        </button>

</form>
</div>
</div>
</div>
</div>
  
</div>

</template>

<script>
import { mapGetters }  from 'vuex';
import api             from "@/api";
export default {
   props : [''],
  components: {},
  data() {
    return {
      color   : '',
      err     : false,
      spinner : false

      
    };
  },
   directives: 
    {
      focus: {
      // directive definition
        inserted: function (el) {
          el.focus()}
       
      }
    },
    computed:
    {
       ...mapGetters(['company'])
    },
  methods: 
  {
    
    

    async saveData()
    {

      this.spinner = true
      var sp   = {'sp'    : 'spCreateColor'}      
      var data = {'color' : this.color,'companyId' : this.company.Id}
      var json = Object.assign(data, sp)
   
      await api.post(json).then(res => {
          
      

          if(res.status==200)
            {
             if(res.data.recordsets[0][0].colorId==0)
            {
                this.err = true
                return
            }
            this.$emit('update') 
                         
            }
           else if(res.status==500)
           {
                console.log(res.data)

                
                    
           } 
           else
            {
                console.log('Network Error.')                  
                 
            } 
      

          }).catch(err => {
              
              console.log(err.message)    

              
          }).finally(() => {
          this.spinner = false
        });



      }
}

}
</script>
<style scoped>

h4 {
  font-family  : 'Roboto Condensed';
  font-size    : 15px;  
}
small {
  font-family  : 'Roboto Condensed';
  font-size    : 15px;
}
.modal-content {
  -webkit-border-radius: 0px !important;
  -moz-border-radius: 0px !important;
  border-radius: 15px !important;
  -webkit-border: 0px !important;
  -moz-border: 15px !important;
  border: 0px !important;
}
</style>


